import dayjs from "dayjs";

export const MEALS = ["breakfast", "lunch", "dinner", "snacks"] as const;
export const MEAL_LABELS: Record<(typeof MEALS)[number], string> = {
  breakfast: "Breakfast",
  lunch: "Lunch",
  dinner: "Dinner",
  snacks: "Snacks",
};

export function kcal(n: number | null | undefined): string {
  return n == null ? "–" : Math.round(n).toLocaleString();
}

export function grams(n: number | null | undefined): string {
  if (n == null) return "–";
  return `${n >= 10 ? Math.round(n) : Math.round(n * 10) / 10} g`;
}

/** Parses a positive decimal typed by a person ("1,5" works too); null if invalid. */
export function parseAmount(text: string): number | null {
  const n = Number(text.trim().replace(",", "."));
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function isoDate(d: dayjs.ConfigType): string {
  return dayjs(d).format("YYYY-MM-DD");
}

export function shiftDay(day: string, by: number): string {
  return isoDate(dayjs(day).add(by, "day"));
}

export function dayLabel(day: string, today: string): string {
  if (day === today) return "Today";
  if (day === shiftDay(today, -1)) return "Yesterday";
  if (day === shiftDay(today, 1)) return "Tomorrow";
  return dayjs(day).format("ddd, D MMM YYYY");
}

/** Nutrients for `factor` × a food's reference serving, rounded like the server does. */
export function scale(value: number | null | undefined, factor: number): number | null {
  return value == null ? null : Math.round(value * factor * 10) / 10;
}
